// extracted by mini-css-extract-plugin
module.exports = {"box":"MerkleProof_box__1zebD","hilite":"MerkleProof_hilite__IyM5Y"};